import { useTranslation } from "react-i18next";
import { z } from "zod";
import { SavingsPlanDataProviderType } from "@services/budget/types";
import { isNullOrUndefined } from "@utils/common";

export const useAddSavingsPlanSchema = () => {
  const { t } = useTranslation();

  const schema = z
    .object({
      planName: z
        .string()
        .trim()
        .refine((value) => value !== "", {
          message: t("common.form.field.errors.required"),
        }),
      planAmount: z.number().or(z.string()),
      endDate: z.date().optional().nullable(),
      savingsPlanDataProviderTypeId: z.nativeEnum(SavingsPlanDataProviderType),
      achievedAmount: z.number().or(z.string()).optional(),
      bankAccountId: z.number().optional(),
    })
    .superRefine((data, ctx) => {
      if (
        data.savingsPlanDataProviderTypeId ===
          SavingsPlanDataProviderType.BankAccountBalance &&
        !data.bankAccountId
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t("common.form.field.errors.required"),
          path: ["bankAccountId"],
        });
      }

      if (
        data.savingsPlanDataProviderTypeId ===
          SavingsPlanDataProviderType.Manual &&
        isNullOrUndefined(data.achievedAmount)
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t("common.form.field.errors.required"),
          path: ["achievedAmount"],
        });
      }
    });

  return schema;
};
export type TAddSavingsPlanSchema = z.infer<
  ReturnType<typeof useAddSavingsPlanSchema>
>;
